import { siteUrl } from "src/api/config";
import { Browser } from "@capacitor/browser";

export const authService = {
  getAccessToken() {
    return sessionStorage.getItem('accessToken');
  },

  setAccessToken(token: string) {
    sessionStorage.setItem('accessToken', token);
  },

  removeAccessToken() {
    sessionStorage.removeItem('accessToken');
  },

  async checkToken(token: string) {
    const response = await fetch(`${siteUrl}/mobile/check`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      credentials: 'omit',
    });

    return response;
  },

  async getUser(token: string) {
    const response = await fetch(`${siteUrl}/mobile/me`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.json();
  },

  async redirectToAuth() {
    const state = crypto.randomUUID();

    sessionStorage.setItem('mobile_auth_state', state);

    const redirectUri = encodeURIComponent("supplyapp://auth");

    const url = `${siteUrl}/mobile/auth/start?redirectUri=${redirectUri}&state=${encodeURIComponent(state)}`
    // Открываем во внешнем браузере
    await Browser.open({ url: url });
  },

  async exchangeCode(code: string) {
    const response = await fetch(`${siteUrl}/mobile/token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ code }),
    });

    if (!response.ok) {
      throw new Error('Token exchange failed');
    }

    return response.json();
  },
};

export const openAdfsLogin = async () => {
  const state = crypto.randomUUID();

  sessionStorage.setItem('mobile_auth_state', state);

  const redirectUri = encodeURIComponent("supplyapp://auth");

  const url = `${siteUrl}/mobile/auth/start?redirectUri=${redirectUri}&state=${encodeURIComponent(state)}`
  // Открываем во внешнем браузере
  await Browser.open({ url: url });
}
